module.exports = __webpack_public_path__ + "img/icon_dot_grey.55348bf2.svg";